export const CHANGE_PASSWORD = '/auth/changepass';
